import React from 'react';
import UIComponent from 'ui-components/ui-component';
import './default-style/select-grid.scss';

class SelectGroup{
    /**
     * @param onValueChange {Function} (remove, add, isManual, component)=>{}
     * @param onValuesChange {Function} (tagNames, isManual, component)=>{}
     * @param canCancel {Boolean} false 是否可取消选择
     * @param canMultiple {Boolean} false 是否可多选
     */
    constructor(onValueChange,onValuesChange,canCancel,canMultiple){
        this.declareVars(onValueChange,onValuesChange,canCancel,canMultiple);
    }
    
    //----------------------------------------内部属性及方法----------------------------------------
    declareVars(onValueChange,onValuesChange,canCancel,canMultiple){
        this._canCancel = canCancel===true ? true : false;
        this._canMultiple = canMultiple===true ? true : false;
        this._onValueChange = onValueChange;
        this._onValuesChange = onValuesChange;
        this._selectGrids = {};
        this._selectedTagNames = [];
        this._oldTagNames = null;
        this._selectedTagName = null;
        this._oldTagName = undefined;

        this._valuesChangeDelay = UIComponent.fns.throttle((isManual)=>{
            const isEqual = UIComponent.fns.ObjectFns.isEqual;
            if(!isEqual(this._oldTagNames, this._selectedTagNames)){
                if(this._onValuesChange){
                    this._onValuesChange([...this._selectedTagNames],isManual,this);
                }
                this._oldTagNames = [...this._selectedTagNames];
            }
        },100,{leading:false});

        this._valueChangeDelay = UIComponent.fns.throttle((isManual)=>{
            if(this._oldTagName !== this._selectedTagName){
                let component = this._selectGrids[this._selectedTagName] || this._selectGrids[this._oldTagName] || null;
                if(this._onValueChange){
                    this._onValueChange(this._oldTagName===undefined ? null : this._oldTagName,this._selectedTagName,isManual,component);
                }
                this._oldTagName = this._selectedTagName;
            }
        },100,{leading: false});
    }

    //----------------------------------------对外属性及方法----------------------------------------
    valueChange(tagName,isSelected,isManual,component){
        if(this._canMultiple){
            if(isSelected){
                this._selectedTagNames = UIComponent.fns.ArrayFns.union(this._selectedTagNames,[tagName]);
            }else{
                this._selectedTagNames = UIComponent.fns.ArrayFns.without(this._selectedTagNames,tagName);
            }
            //----------触发valuesChange----------
            this._valuesChangeDelay(isManual);
        }else{
            //----------切换选择项----------
            if(isSelected && this._selectedTagName!==tagName){
                if(this._selectedTagName !== null){//----------取消已选择----------
                    try{
                        this._selectGrids[this._selectedTagName].isSelected = false;
                    }catch (e) {}
                }
                this._selectedTagName = tagName;
                this._valueChangeDelay(isManual);
            }else if(!isSelected && this._selectedTagName===tagName){
                if(this._canCancel){//----------如果可取消----------
                    this._selectedTagName = null;
                    this._valueChangeDelay(isManual);
                }else{//----------如果不可取消----------
                    try{
                        this._selectGrids[tagName].isSelected = true;
                    }catch (e) {}
                }
            }
        }
    }

    changeDelay(){
        if(this._canMultiple){
            this._valuesChangeDelay(false);
        }else{
            this._valueChangeDelay(false);
        }
    }

    add(tagName,grid){
        const TypesCheck = UIComponent.fns.TypesCheck;
        if(!TypesCheck.isString(tagName) && !TypesCheck.isNumber(tagName)){
            console.error("添加至Group的SelectGrid组件的tagName必须为字符串或数字~！");
            return;
        }
        this._selectGrids[tagName] = grid;
        if(grid.isSelected){
            if(this._canMultiple){
                this._selectedTagNames = UIComponent.fns.ArrayFns.union(this._selectedTagNames,[tagName]);
            }else{
                this._selectedTagName = tagName;
            }
        }
    }

    remove(tagName){
        delete this._selectGrids[tagName];
        if(this._canMultiple){
            let index = this._selectedTagNames.indexOf(tagName);
            if(index !== -1){
                this._selectedTagNames.splice(index,1);
            }
        }else{
            if(this._selectedTagName === tagName){
                this._selectedTagName = null;
            }
        }
    }
}

/**
 * isSelected {Boolean} 是否选择
 * selectGroup {SelectGroup} 选择组
 * onValueChange {Function} (tagName, isSelected, isManual, component)=>{}
 *
 * 以下属性属于内部赋值属性
 * isControlled:{Boolean} false 是否为受控组件
 * onPointClick:{Function} (tagName, component)=>{}
 */
export default class SelectGrid extends UIComponent{
    get className(){
        let className = super.className;
        return className?className:"default-select-grid";
    }
    set className(className){
        super.className = className;
    }

    get selectedClass(){
        return this.className + "-selected";
    }

    getClassName(){
        let className = super.getClassName();
        if(this.selectedClass){
            className[this.selectedClass] = this.isSelected;
        }
        return className;
    }

    get controlledProps(){
        return [...super.controlledProps,"isSelected"];
    }

    //-------------------------------------------------内部属性及方法-------------------------------------------------
    declareVars(){
        super.declareVars();
        this._isManual = false;
        this._oldValue = null;
        this.onValueChange = null;
    }

    get selectGroup(){
        return this.props.selectGroup;
    }

    groupValueChange(){
        if(this.selectGroup instanceof SelectGroup){
            this.selectGroup.valueChange(this.tagName, this.isSelected, this._isManual, this);
        }
    }

    get isControlled(){
        return this.props.isControlled===true ? true : false;
    }

    //-------------------------------------------------对外属性及方法-------------------------------------------------
    get isSelected(){
        if(this.isControlled){
            return this.props.isSelected;
        }
        return this.state.isSelected === true ? true : false;
    }
    set isSelected(isSelected){
        if(this.isControlled){
            console.warn("当前SelectGrid组件是受控组件，仅允许通过Props来改变当前值。");
            return;
        }
        this.setState({isSelected:isSelected});
    }

    //-------------------------------------------------组件结构生命周期-------------------------------------------------
    pointClick(e){
        super.pointClick(e);
        e.stopPropagation();
        if(this.isControlled){
            if(this.props.onPointClick){
                this.props.onPointClick(this.tagName, this);
            }
            return;
        }
        this._isManual = true;
        this.isSelected = !this.isSelected;
    }

    domDidChange(){
        super.domDidChange();
        if(this.isControlled){
            return;
        }
        if(!this._firstInit){
            if(this.propsHasChanged("selectGroup")){
                if(this.selectGroup){
                    this.selectGroup.add(this.tagName,this);
                    this.selectGroup.changeDelay();
                }
            }else if(this.propsHasChanged("tagName")){
                if(this.selectGroup){
                    let changedTagName = this.changedProps.tagName;
                    this.selectGroup.remove(changedTagName.last);
                    this.selectGroup.changeDelay();
                    setTimeout(()=>{
                        this.selectGroup.add(this.tagName,this);
                        this.selectGroup.changeDelay();
                    })
                }
            }
        }
        this.valueChange();
    }

    componentDidMount() {
        super.componentDidMount();
        if(this.isControlled){
            return;
        }
        if(this.selectGroup){
            this.selectGroup.add(this.tagName,this);
            if(!this.selectGroup._canMultiple){
                this.selectGroup.changeDelay();
            }
        }
    }

    componentWillUnmount() {
        super.componentWillUnmount();
        if(this.isControlled){
            return;
        }
        if(this.selectGroup){
            this.selectGroup.remove(this.tagName);
            this.selectGroup.changeDelay();
        }
    }

    valueChange(){
        if(this._oldValue !== this.isSelected){
            if(this.props.onValueChange){
                this.props.onValueChange(this.tagName,this.isSelected,this._isManual,this);
            }
            if(this.onValueChange){
                this.onValueChange(this.tagName,this.isSelected,this._isManual,this);
            }
            this._oldValue = this.isSelected;
            this.groupValueChange();
        }
        this._isManual = false;
    }
}

SelectGrid.SelectGroup = SelectGroup;